
<template>
  <span>{{ display }}</span>
</template>

<script>
import cellRendererMixin from '../../mixins/cellRenderer.mixin'

export default {
  mixins: [cellRendererMixin]

}
</script>

<style scoped>

</style>
